<template>
  <div class="dynamic-tables">
    <h2 class="page-title text-center">Data Penilaian Laporan Tahunan</h2>
    <Widget customHeader>
      <div>
        <!-- prettier-ignore -->
        <div class="d-flex justify-content-between">
          <div>
            <button type="button" class="btn btn-success" @click="exportData">
              <i class="fa fa-file-text-o"></i> Excel
            </button>
          </div>
          <div class="d-flex align-items-start">
            <div class="d-flex flex-column">
              <div v-for="(filter, index) in filters" :key="index" class="d-flex align-items-center mb-2">
                <label class="mr-2 mb-0 text-nowrap">Filter {{ index + 1 }}</label>
                <select v-model="filter.field" class="form-control mr-2" @change="resetFilter(filter)">
                  <option
                    v-for="option in filterFields"
                    :key="option.value"
                    :value="option.value"
                    :disabled="isFieldSelected(option.value, filter.field)"
                  >{{ option.label }}</option>
                </select>
                <div v-if="isRangeSearch(filter.field)" class="d-flex align-items-center">
                  <label class="mb-0 mr-1">Mulai</label>
                  <input
                    v-model="filter.from"
                    :type="filter.field === 'total_skor' ? 'number' : 'date'"
                    class="form-control mr-2"
                  />
                  <label class="mb-0 mr-1">Sampai</label>
                  <input
                    v-model="filter.to"
                    :type="filter.field === 'total_skor' ? 'number' : 'date'"
                    class="form-control mr-2"
                  />
                </div>
                <select
                  v-else-if="filter.field === 'kategori_penilaian'"
                  v-model="filter.value"
                  class="form-control mr-2"
                >
                  <option value="">Pilih Kategori</option>
                  <option value="Sangat Baik">Sangat Baik</option>
                  <option value="Baik">Baik</option>
                  <option value="Cukup">Cukup</option>
                  <option value="Kurang">Kurang</option>
                  <option value="Sangat Kurang">Sangat Kurang</option>
                </select>
                <input
                  v-else-if="filter.field !== 'provinsi'"
                  v-model="filter.value"
                  type="text"
                  class="form-control mr-2"
                />
                <div v-else class="mr-2" style="min-width: 200px;">
                  <v-select
                    v-model="filter.value"
                    :options="dataProvinsi"
                    :reduce="(d) => d.nama_provinsi"
                    label="nama_provinsi"
                    placeholder="Pilih Lokasi..."
                  />
                </div>
                <button
                  v-if="index > 0"
                  type="button"
                  class="btn btn-outline-danger"
                  @click="removeFilter(index)"
                >Hapus</button>
              </div>
              <button
                v-if="filters.length < 3"
                type="button"
                class="btn btn-outline-primary align-self-start"
                @click="addFilter"
              >Tambah Filter</button>
            </div>
            <div class="d-flex ml-4">
              <div class="d-flex align-items-center mr-2">
                <label for="search" class="mb-0">Sort By: </label>
              </div>
              <div>
                <select v-model="sort.field" class="form-control">
                  <option value="tanggal_penerbitan">Tgl. Izin Terbit</option>
                  <option value="tahun_laporan">Tahun Laporan</option>
                  <option value="tanggal_submit_laporan">Tgl. Pelaporan</option>
                  <option value="masa_berlaku">Masa Berlaku</option>
                  <option value="tanggal_penilaian">Tgl. Penilaian</option>
                </select>
              </div>
              <div class="ml-2">
                <select v-model="sort.direction" class="form-control">
                  <option value="DESC">DESC</option>
                  <option value="ASC">ASC</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <table id="tabel_laporan_tahunan" class="table" style="width: 100%">
          <thead>
            <tr>
              <th>No</th>
              <th>Nama Pemohon</th>
              <th>Jenis Permohonan</th>
              <th>Nomor Izin Terbit</th>
              <th>Tgl. Izin Terbit</th>
              <th>Tahun Laporan</th>
              <th>Tgl. Pelaporan</th>
              <th>Status Penyampaian</th>
              <th>Lokasi</th>
              <th>Verifikator</th>
              <th>Nilai</th>
              <th>Skor</th>
              <th>Kategori</th>
              <th>Masa Berlaku</th>
              <th>Rekomendasi Penilaian KKPRL</th>
              <th>Persetujuan Lingkungan</th>
              <th>Ket. Persetujuan Lingkungan</th>
              <th>Perizinan Usaha</th>
              <th>Ket. Perizinan Usaha</th>
              <th>Nomor Tanda Terima</th>
              <th>Status</th>
              <th>Penilai</th>
              <th>Tgl. Penilaian</th>
              <th>Unduh File</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(data, index) in dataLaporan"
              :key="index"
              :class="[
                {
                  'text-danger': data.status_laporan === 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan',
                },
              ]"
            >
              <!-- No -->
              <td>{{ index + pagination.firstInPage }}</td>
              <!-- Nama Pemohon -->
              <td>
                <div style="width: 300px; white-space: normal">
                  {{ data.nama_pemegang }}
                </div>
              </td>
              <!-- Jenis Permohonan -->
              <td>{{ data.jenis_kegiatan }}</td>
              <!-- Nomor Izin Terbit -->
              <td>{{ data.nomor_kkprl }}</td>
              <!-- Tgl. Izin Terbit -->
              <td>{{ formatDate(data.tanggal_penerbitan, 'DD MMMM YYYY') }}</td>
              <!-- Tahun Laporan -->
              <td>{{ data.tahun_laporan }}</td>
              <!-- Tgl. Pelaporan -->
              <td>
                {{ formatDate(data.tanggal_submit_laporan, 'DD MMMM YYYY') }}
              </td>
              <!-- Status Penyampaian -->
              <td>{{ data.status_penyampaian }}</td>
              <!-- Lokasi -->
              <td>
                {{ data.provinsi || '-' }}
              </td>
              <!-- Verifikator -->
              <td>
                {{ data.jenis_verifikator || '-' }}
              </td>
              <!-- Nilai -->
              <td>{{ data.nilai || '-' }}</td>
              <!-- Skor -->
              <td>{{ data.total_skor || '-' }}</td>
              <!-- Kategori -->
              <td>{{ data.kategori_penilaian || '-' }}</td>
              <!-- Masa Berlaku -->
              <td>{{ formatDate(data.masa_berlaku, 'DD MMMM YYYY') || data.masa_berlaku || '-' }}</td>
              <!-- Rekomendasi Penilaian KKPRL -->
              <td>{{ data.rekomendasi_penilaian_kkprl || '-' }}</td>
              <!-- Persetujuan Lingkungan -->
              <td>
                <div style="width: 250px; white-space: normal">
                  {{ data.persetujuan_lingkungan }}
                </div>
              </td>
              <!-- Ket. Persetujuan Lingkungan -->
              <td>
                <div style="width: 250px; white-space: normal">
                  {{ data.ket_persetujuan_lingkungan }}
                </div>
              </td>
              <!-- Perizinan Usaha -->
              <td>
                <div style="width: 250px; white-space: normal">
                  {{ data.perizinan_usaha }}
                </div>
              </td>
              <!-- Ket. Perizinan Usaha -->
              <td>
                <div style="width: 250px; white-space: normal">
                  {{ data.ket_perizinan_usaha }}
                </div>
              </td>
              <!-- Nomor Tanda Terima -->
              <td>{{ data.nomor_tanda_terima }}</td>
              <!-- Status -->
              <td>{{ data.status_laporan }}</td>
              <!-- Penilai -->
              <td>{{ data.nama_penilai || '-' }}</td>
              <!-- Tgl. Penilaian -->
              <td>
                {{ data.tanggal_penilaian ? formatDate(data.tanggal_penilaian) : '-' }}
              </td>
              <!-- Unduh File -->
              <td>
                <div style="width: 250px" class="row">
                  <div class="col-8">
                    <select style="width: 150px; margin-right: 10px" class="form-select" v-model="data.selected_file">
                      <option disabled selected value="">- Pilih File -</option>
                      <option
                        :value="`${data.id_file_tanda_terima_laporan}`"
                        :disabled="!data.id_file_tanda_terima_laporan"
                      >
                        Tanda Terima
                      </option>
                      <option :value="`${data.id_file_final_surat_tugas}`" :disabled="!data.id_file_final_surat_tugas">
                        Surat Tugas
                      </option>
                      <option
                        :value="`${data.id_filename_hasil_penilaian}`"
                        :disabled="!data.id_filename_hasil_penilaian"
                      >
                        Hasil Penilaian
                      </option>
                      <option :value="`${data.id_file_sertifikat}`" :disabled="!data.id_file_sertifikat">
                        Sertifikat Apresiasi
                      </option>
                      <option :value="`${data.id}:merged`" :disabled="data.status_laporan !== 'Selesai'">
                        Dokumen Laporan Lengkap
                      </option>
                    </select>
                  </div>
                  <div class="col-4 d-flex align-items-center">
                    <span v-if="data.selected_file !== '#'">
                      <a href="#" @click="unduhFile(data.selected_file)">
                        <i class="fa fa-download" style="font-size: 20px"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </td>
              <!-- Aksi -->
              <td>
                <div style="width: 200px">
                  <b-button-toolbar>
                    <b-button size="sm" class="text-white m-1 bg-primary" @click="showModalTracking(data.id, index)">
                      <i class="fa fa-search"></i> Tracking
                    </b-button>
                    <b-button
                      v-if="hasRole(user, 'Superuser') && getStatusLaporan(data) === 2"
                      size="sm"
                      variant="secondary"
                      class="text-white m-1"
                      @click="showModalFinalisasi(data.id)"
                    >
                      <i class="fa fa-check"></i>
                      Buat Tanda Terima
                    </b-button>
                    <b-button
                      v-if="hasRole(user, 'Superuser') && getStatusLaporan(data) === 2"
                      size="sm"
                      variant="warning"
                      class="text-white m-1"
                      @click="showModalCatatan(data.id)"
                    >
                      <i class="fa fa-sticky-note-o"></i>
                      Catatan
                    </b-button>
                    <b-button
                      v-if="hasRole(user, ['Superuser', 'Verifikator']) || (hasRole(user, 'Penilai') && data.status_laporan === 'Selesai')"
                      size="sm"
                      variant="info"
                      class="text-white m-1"
                      @click="tinjauLaporan(data.id)"
                    >
                      <i class="fa fa-eye"></i> Tinjau Penilaian Laporan
                    </b-button>
                    <b-button
                      v-if="hasRole(user, 'Superuser') && getStatusLaporan(data) >= 3 && getStatusLaporan(data) <= 4"
                      size="sm"
                      class="text-white m-1"
                      style="background-color: #83c6f3"
                      @click="handleRollback(data.id)"
                    >
                      <i class="fa fa-history"></i>
                      Rollback
                    </b-button>
                    <b-button
                      v-if="hasRole(user, 'Verifikator') && getStatusLaporan(data) === 3"
                      size="sm"
                      class="text-white m-1"
                      style="background: #8b5cf6"
                      @click="showModalSuratTugas(data.id)"
                    >
                      <i class="fa fa-file-o"></i>
                      Surat Tugas
                    </b-button>
                    <b-button
                      v-if="hasRole(user, 'Penilai') && isValidPenilai(data) && getStatusLaporan(data) >= 3 && getStatusLaporan(data) <= 4"
                      size="sm"
                      variant="success"
                      class="text-white m-1"
                      @click="verifikasiLaporan(data.id)"
                    >
                      <i class="fa fa-check-square-o"></i>
                      Verifikasi Laporan
                    </b-button>
                    <b-button
                      v-if="hasRole(user, 'Penilai') && getStatusLaporan(data) >= 4"
                      size="sm"
                      style="background-color: #ff6d1f"
                      :class="['text-white m-1', { 'btn-diskusi-active': data.unread_chat }]"
                      @click="toggleModalChat(data)"
                    >
                      <i class="bi bi-chat"></i> Diskusi
                    </b-button>
                    <button
                      v-if="hasRole(user, 'Penilai') && isValidPenilai(data) && getStatusPenilaian(data) === 0"
                      class="btn-submit m-1"
                      @click="submitPenilaian(data)"
                    >
                      <i class="fa fa-check-square"></i>
                      Submit Penilaian
                    </button>
                    <b-button
                      v-if="hasRole(user, 'Superuser')"
                      size="sm"
                      variant="danger"
                      class="text-white m-1"
                      @click="deleteLaporan(data.id)"
                    >
                      <i class="fa fa-trash-o"></i> Hapus Laporan
                    </b-button>
                  </b-button-toolbar>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- prettier-ignore -->
        <div class="d-flex justify-content-between mt-4">
          <div>
            <template v-if="pagination.total">
              Menampilkan {{ pagination.firstInPage }} sampai {{ pagination.currentPage !== pagination.lastPage ? pagination.limit*pagination.currentPage : pagination.total }} dari {{ pagination.total }} data
            </template>
          </div>
          <nav aria-label="Page navigation example">
            <ul class="pagination">
              <li :class="['page-item', {'disabled': pagination.currentPage === 1}]">
                <a class="page-link" href="#" aria-label="Previous" @click="changePage({option: 'first'})">
                  <span aria-hidden="true">Awal</span>
                </a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === 1}]">
                <a class="page-link" href="#" aria-label="Previous" @click="changePage({option: 'prev'})">
                  <span aria-hidden="true">Sebelumnya</span>
                </a>
              </li>
              <li 
                v-for="i in pagination.pageNumber" 
                class="page-item"
              >
                <a :class="['page-link', {'active': i === `${pagination.currentPage}`}]" href="#" @click="changePage({page: i})">{{ i }}</a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === pagination.lastPage}]">
                <a class="page-link" href="#" aria-label="Next" @click="changePage({option: 'next'})">
                  <span aria-hidden="true">Selanjutnya</span>
                </a>
              </li>
              <li :class="['page-item', {'disabled': pagination.currentPage === pagination.lastPage}]">
                <a class="page-link" href="#" aria-label="Next" @click="changePage({option: 'last'})">
                  <span aria-hidden="true">Akhir</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </Widget>

    <b-modal body-class="bg-white" id="modal-surat-tugas" scrollable title="Surat Tugas">
      <form>
        <b-row class="g-4">
          <b-col md="12">
            <label for="id_penilai">Kepada Tim Penilai :</label>
            <v-select
              id="id_penilai"
              :options="dataTimPenilai"
              v-model="formSuratTugas.id_penilai"
              :reduce="(d) => d.id"
              label="nama"
              name="Tim Penilai"
            />
            <span class="text-danger" v-if="errors.has('Tim Penilai')">
              {{ errors.first('Tim Penilai') }}
            </span>
          </b-col>
          <b-col md="12" class="mt-3">
            <label for="penandatangan">Penandatangan :</label>
            <v-select
              id="penandatangan"
              :options="dataPenandatangan"
              v-model="formSuratTugas.penandatangan"
              :reduce="(d) => d.id"
              label="nama"
              name="Penandatangan"
            />
            <span class="text-danger" v-if="errors.has('Penandatangan')">
              {{ errors.first('Penandatangan') }}
            </span>
          </b-col>
          <b-col md="12" class="mt-3">
            <div>
              <label for="dipa">DIPA :</label>
              <b-form-textarea
                id="dipa"
                class="form-control"
                type="text"
                rows="3"
                v-model="formSuratTugas.dipa"
                name="DIPA"
              />
              <span class="text-danger" v-if="errors.has('DIPA')">
                {{ errors.first('DIPA') }}
              </span>
            </div>
          </b-col>
          <!-- <b-col md="12" class="mt-3">
            <label>Paragraf Penutup :</label>
            <ckeditor id="paragraf_penutup" :editor="wygEditor" v-model="formSuratTugas.paragraf_penutup"></ckeditor>
            <span class="text-danger" v-if="errors.has('Paragraf Penutup')">
              {{ errors.first('Paragraf Penutup') }}
            </span>
          </b-col> -->
          <b-col md="12" class="mt-3">
            <div>
              <label for="tempat_ttd">Tempat Tandatangan :</label>
              <b-form-input
                id="tempat_ttd"
                class="form-control"
                type="text"
                v-model="formSuratTugas.tempat_ttd"
                name="Tempat Tandatangan"
              />
              <span class="text-danger" v-if="errors.has('Tempat Tandatangan')">
                {{ errors.first('Tempat Tandatangan') }}
              </span>
            </div>
          </b-col>
          <b-col md="12" class="mt-3">
            <div>
              <label for="tanggal_surat">Tanggal Surat :</label>
              <input
                id="tanggal_surat"
                class="form-control"
                type="date"
                v-model="formSuratTugas.tanggal_surat"
                name="Tanggal Surat"
              />
              <span class="text-danger" v-if="errors.has('Tanggal Surat')">
                {{ errors.first('Tanggal Surat') }}
              </span>
            </div>
          </b-col>
        </b-row>
      </form>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="saveSuratTugas" :disabled="loadingModal">
            <i class="fa fa-floppy-o text-white"></i>
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modal-finalisasi-tanda-terima" title="Buat Tanda Terima" size="md">
      <template>
        <b-form>
          <div class="row g-0">
            <div class="col-12">
              <label>Jenis KKPRL</label>
              <v-select
                v-model="formFinalisasiTandaTerima.jenis_kkprl"
                id="jenis_kkprl"
                :options="['Persetujuan', 'Konfirmasi']"
                name="Jenis KKPRL"
                v-validate="'required'"
              />
              <span class="text-danger" v-if="errors.has('Jenis KKPRL')">
                {{ errors.first('Jenis KKPRL') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label>Kategori</label>
              <v-select
                v-model="formFinalisasiTandaTerima.kategori"
                id="kategori"
                :options="['Pelaku Usaha', 'Perorangan', 'Pemerintah', 'Pemerintah Daerah', 'Lainnya']"
                name="Kategori"
                v-validate="'required'"
              />
              <span class="text-danger" v-if="errors.has('Kategori')">
                {{ errors.first('Kategori') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label>Petugas Penerima</label>
              <v-select
                v-model="formFinalisasiTandaTerima.id_petugas_penerima"
                id="petugas_penerima"
                :reduce="(data) => data.id"
                label="nama"
                :options="dataPetugasPenerima"
                name="Petugas Penerima"
                v-validate="'required'"
              />
              <span class="text-danger" v-if="errors.has('Petugas Penerima')">
                {{ errors.first('Petugas Penerima') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label>Verifikator</label>
              <v-select
                v-model="formFinalisasiTandaTerima.jenis_verifikator"
                id="jenis_verifikator"
                :options="['Pusat', 'UPT']"
                name="Verifikator"
                v-validate="'required'"
              />
              <span class="text-danger" v-if="errors.has('Verifikator')">
                {{ errors.first('Verifikator') }}
              </span>
            </div>
            <div class="col-12 mt-3">
              <label>Catatan</label>
              <ckeditor
                id="catatan"
                :editor="wygEditor"
                v-model="formFinalisasiTandaTerima.catatan_penerimaan"
                name="Catatan"
              ></ckeditor>
            </div>
          </div>
        </b-form>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="saveFinalisasiTandaTerima"
            :disabled="loadingModal"
          >
            <img src="../../assets/icons/archive.svg" />
            Buat
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modal-catatan" title="Catatan" size="md">
      <template>
        <b-form>
          <div class="row g-0">
            <div class="col-12">
              <label>Catatan</label>
              <ckeditor
                id="catatan"
                :editor="wygEditor"
                v-model="formCatatan"
                name="Catatan"
                v-validate="'required'"
              ></ckeditor>
              <span class="text-danger" v-if="errors.has('Catatan')">
                {{ errors.first('Catatan') }}
              </span>
            </div>
          </div>
        </b-form>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" size="sm" class="float-right" @click="sendCatatan">
            <i class="fa fa-paper-plane-o"></i>
            Kirim
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modal-tracking" title="Tracking Laporan Tahunan" size="lg" scrollable>
      <template>
        <ul class="timeline">
          <li v-for="(item, index) in trackingPermohonan">
            <span class="eventIcon eventIconPrimary"></span>
            <section class="event p-0">
              <div class="m-3">
                <span class="thumb-xs avatar pull-left me-sm-1"> </span>
                <h5 class="eventHeading">
                  <a href="#">{{ item.status_laporan }}</a>
                </h5>
                <small>{{ item.nama_pemegang }}</small>
                <p class="fs-sm text-muted">
                  {{ formatDate(item.createdAt, 'HH:mm - DD MMMM YYYY') }}
                </p>
                <div class="text-danger" v-html="item.catatan"></div>
              </div>
            </section>
          </li>
        </ul>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="danger" size="sm" class="float-right" @click="$bvModal.hide('modal-tracking')">
            Tutup
          </b-button>
        </div>
      </template>
    </b-modal>

    <ModalChat :data-laporan="selectedLaporan" />
  </div>
</template>

<style scoped>
table.table.b-table > thead > tr > th[aria-sort='ascending']::after,
table.table.b-table > tfoot > tr > th[aria-sort='ascending']::after {
  opacity: 1;
  content: '\2191';
}

.dt-button.btn.btn-primary {
  border: none;
}

.dt-button.btn.btn-primary:hover {
  background-color: #35a0fd !important;
  border: none;
}

.modal-body {
  background: white !important;
}

#tabel_laporan_tahunan_info,
#tabel_laporan_tahunan_paginate,
#tabel_laporan_tahunan_filter {
  display: none;
}
</style>

<script>
import Widget from '@/components/Widget/Widget'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import vSelect from 'vue-select'
import { exportToExcel, formatDate, openFileById, hasRole } from '../../helper/helpernew'
import axios from 'axios'
import Swal from 'sweetalert2'
import DatePicker from 'vue2-datepicker'
import InputFile from './Components/InputFile.vue'
import ModalChat from '../../components/ModalChat/ModalChat.vue'

export default {
  name: 'Dynamic',
  components: { Widget, vSelect, DatePicker, InputFile, ModalChat },
  data() {
    return {
      id_laporan_tahunan: null,
      id_surat_tugas: null,
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      formTimPenilai: {
        id_penilai: null,
      },
      loadingModal: false,
      formFinalisasiTandaTerima: {
        jenis_kkprl: '',
        kategori: '',
        id_petugas_penerima: '',
        jenis_verifikator: '',
        catatan_penerimaan: '',
      },
      formSuratTugas: {
        id_penilai: '',
        // nomor_surat: '',
        // menimbang: '',
        // dasar: '',
        // untuk: '',
        // paragraf_penutup: '',
        penandatangan: '',
        dipa: '',
        // catatan_surat: '',
        tempat_ttd: '',
        tanggal_surat: '',
      },
      dataSuratTugas: null,
      formCatatan: '',
      formPenilaian: {
        nomor_berita_acara: '',
      },
      selectedLaporan: null,
      dataLaporan: [],
      dataProvinsi: [],
      popoverShow: {},
      trackingPermohonan: [],
      tgl_surat: 'dd/mm/yyyy',
      dataPetugasPenerima: [],
      dataTimPenilai: [],
      dataPenandatangan: [],
      wygEditor: ClassicEditor,
      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: null,
        pageNumber: [],
        limit: 0,
        total: 0,
        firstInPage: 0,
      },
      filterFields: [
        { value: 'nama_pemegang', label: 'Nama Pemohon' },
        { value: 'jenis_kegiatan', label: 'Jenis Permohonan' },
        { value: 'nomor_kkprl', label: 'Nomor Izin Terbit' },
        { value: 'tanggal_penerbitan', label: 'Tgl. Izin Terbit' },
        { value: 'tahun_laporan', label: 'Tahun Laporan' },
        { value: 'tanggal_submit_laporan', label: 'Tgl. Pelaporan' },
        { value: 'provinsi', label: 'Lokasi' },
        { value: 'jenis_verifikator', label: 'Verifikator' },
        { value: 'nilai', label: 'Nilai' },
        { value: 'total_skor', label: 'Skor' },
        { value: 'kategori_penilaian', label: 'Kategori' },
        { value: 'masa_berlaku', label: 'Masa Berlaku' },
        { value: 'rekomendasi_penilaian_kkprl', label: 'Rekomendasi Penilaian KKPRL' },
        { value: 'nomor_tanda_terima', label: 'Nomor Tanda Terima' },
        { value: 'status_laporan', label: 'Status' },
        { value: 'nama_penilai', label: 'Penilai' },
      ],
      filters: [{ field: 'nama_pemegang', value: '', from: '', to: '' }],
      sort: {
        field: 'tanggal_submit_laporan',
        direction: 'DESC',
      },
      debounceTerm: null,
    }
  },
  mounted() {
    this.getProvinsi()
    this.loadData()
  },
  methods: {
    formatDate,
    openFileById,
    exportToExcel,
    hasRole,

    isRangeSearch(field) {
      return ['tanggal_penerbitan', 'tanggal_submit_laporan', 'total_skor', 'masa_berlaku'].includes(field)
    },

    isFieldSelected(field, currentField) {
      return field !== currentField && this.filters.some((filter) => filter.field === field)
    },

    resetFilter(filter) {
      filter.value = ''
      filter.from = ''
      filter.to = ''
    },

    addFilter() {
      const field = this.filterFields.find((option) => !this.filters.some((filter) => filter.field === option.value))
      if (field && this.filters.length < 3) {
        this.filters.push({ field: field.value, value: '', from: '', to: '' })
      }
    },

    removeFilter(index) {
      this.filters.splice(index, 1)
    },

    getSearchFilter() {
      return this.filters.reduce((conditions, filter) => {
        if (this.isRangeSearch(filter.field)) {
          conditions.push(...[
            filter.from !== '' && `${filter.field},>=,${filter.from}`,
            filter.to !== '' && `${filter.field},<=,${filter.to}`,
          ].filter(Boolean))
          return conditions
        }
        if (filter.value !== '' && filter.value !== null) {
          const operator = filter.field === 'kategori_penilaian' ? '=' : filter.field === 'provinsi' ? 'contains' : 'like'
          conditions.push(`${filter.field},${operator},${filter.value}`)
        }
        return conditions
      }, []).join(';')
    },

    getProvinsi() {
      axios
        .get(this.baseapiPengendalian + 'api/provinsi?sort=id,ASC&limit=0', this.getApiOption())
        .then((response) => {
          this.dataProvinsi = response.data.data
        })
    },

    showModalTracking(id, index) {
      // this.selectedPermohonan = this.dataLaporan[index]
      axios
        .get(this.baseapiPengendalian + `api/status_laporan_tahunan?filter=id_laporan,=,${id}`, this.getApiOption())
        .then((res) => {
          this.trackingPermohonan = res.data.data
        })
      this.$bvModal.show('modal-tracking')
    },

    sendCatatan() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          axios
            .post(
              this.baseapiPengendalian + `api/laporan_tahunan/${this.id_laporan_tahunan}`,
              { catatan_laporan_tahunan: this.formCatatan },
              this.getApiOption(),
            )
            .then((res) => {
              Swal.fire('Berhasil', 'Berhasil mengirim catatan', 'success')
              this.$bvModal.hide('modal-catatan')
              this.formCatatan = ''
              this.loadData()
            })
            .catch((err) => {
              Swal.fire('Gagal', 'Gagal mengirim catatan', 'error')
            })
        }
      })
    },

    showModalCatatan(id_laporan) {
      this.id_laporan_tahunan = id_laporan
      this.$bvModal.show('modal-catatan')

      // axios.get(this.baseapiPengendalian + `api/laporan_tahunan/${id_laporan}`, this.getApiOption()).then((res) => {
      //   if (res.data?.data?.catatan_laporan_tahunan) {
      //     this.formCatatan = res.data.data.catatan_laporan_tahunan
      //   }
      // })
    },

    showModalFinalisasi(id) {
      this.id_laporan_tahunan = id
      this.$bvModal.show('modal-finalisasi-tanda-terima')

      axios
        .get(this.baseapiPengendalian + 'api/user?filter=role,!=,Pemrakarsa&limit=0', this.getApiOption())
        .then((response) => {
          this.dataPetugasPenerima = response.data.data.filter((d) => {
            return this.hasRole(d, 'Superuser')
          })
        })
        .catch((error) => {})
    },

    async saveFinalisasiTandaTerima() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          const formData = {}
          for (const d in this.formFinalisasiTandaTerima) {
            formData[d] = this.formFinalisasiTandaTerima[d]
          }

          try {
            this.$loading(true)
            this.loadingModal = true
            const res = await axios.put(
              `${this.baseapiPengendalian}api/laporan_tahunan/getTandaTerima/${this.id_laporan_tahunan}`,
              formData,
              this.getApiOption(),
            )
            if (res.data?.data?.id_file_final) {
              this.openFileById(res.data?.data?.id_file_final)
              await axios.post(
                `${this.baseapiPengendalian}api/laporan_tahunan/${this.id_laporan_tahunan}`,
                { id_file_tanda_terima_laporan: res.data?.data?.id_file_final },
                this.getApiOption(),
              )
            }
            Swal.fire('Berhasil', 'Berhasil membuat Tanda Terima', 'success')
            this.$bvModal.hide('modal-finalisasi-tanda-terima')
            this.loadData()
            for (const d in this.formFinalisasiTandaTerima) {
              this.formFinalisasiTandaTerima[d] = ''
            }
          } catch (error) {
            Swal.fire('Gagal', 'Gagal membuat Tanda Terima', 'error')
          } finally {
            this.$loading(false)
            this.loadingModal = false
          }
        }
      })
    },

    async showModalSuratTugas(id) {
      const st = await axios.get(
        `${this.baseapiPengendalian}api/surat_tugas_laporan?filter=id_laporan,=,${id}`,
        this.getApiOption(),
      )
      const dataSt = st?.data?.data[0]
      if (dataSt) {
        for (const d in this.formSuratTugas) {
          this.formSuratTugas[d] = dataSt[d]
        }
        this.dataSuratTugas = dataSt
      } else {
        for (const d in this.formSuratTugas) {
          this.formSuratTugas[d] = ''
        }
        this.dataSuratTugas = null
      }

      this.id_laporan_tahunan = id
      const res = await axios.get(
        `${this.baseapiPengendalian}api/user?filter=role,!=,Pemrakarsa;nama_upt,=,${this.user.nama_upt}&limit=0`,
        this.getApiOption(),
      )
      this.dataTimPenilai = res.data.data.filter((d) => {
        return this.hasRole(d, 'Penilai')
      })
      const res2 = await axios.get(`${this.baseapiPengendalian}api/user?filter=role,=,Pejabat&limit=0`, this.getApiOption())
      this.dataPenandatangan = res2.data.data
      this.$bvModal.show('modal-surat-tugas')
    },

    async saveSuratTugas() {
      this.manualValidation(this.formSuratTugas.id_penilai, 'Tim Penilai')
      // this.manualValidation(this.formSuratTugas.nomor_surat, 'Nomor Surat')
      // this.manualValidation(this.formSuratTugas.menimbang, 'Menimbang')
      // this.manualValidation(this.formSuratTugas.dasar, 'Dasar')
      // this.manualValidation(this.formSuratTugas.untuk, 'Untuk')
      this.manualValidation(this.formSuratTugas.penandatangan, 'Penandatangan')
      this.manualValidation(this.formSuratTugas.dipa, 'DIPA')
      // this.manualValidation(this.formSuratTugas.paragraf_penutup, 'Paragraf Penutup')
      this.manualValidation(this.formSuratTugas.tempat_ttd, 'Tempat Tandatangan')
      this.manualValidation(this.formSuratTugas.tanggal_surat, 'Tanggal Surat')
      if (this.$validator.errors.any()) return

      const formData = {
        id_laporan: this.id_laporan_tahunan,
        ...this.formSuratTugas,
      }

      const id_st = this.dataSuratTugas?.id || null
      try {
        this.$loading(true)
        this.loadingModal = true
        if (id_st) {
          const res = await axios.put(
            `${this.baseapiPengendalian}api/surat_tugas_laporan/${id_st}`,
            formData,
            this.getApiOption(),
          )
          if (res?.data?.data?.id_file_final) {
            this.openFileById(res?.data?.data?.id_file_final)
          }
        } else {
          const res = await axios.post(
            `${this.baseapiPengendalian}api/surat_tugas_laporan`,
            formData,
            this.getApiOption(),
          )
          if (res?.data?.data?.id_file_final) {
            this.openFileById(res?.data?.data?.id_file_final)
          }
        }
        await axios.post(
          `${this.baseapiPengendalian}api/laporan_tahunan/${this.id_laporan_tahunan}`,
          { status_pembuatan_surat_tugas: 'Selesai', status_laporan: 'Laporan sedang dalam proses penilaian' },
          this.getApiOption(),
        )
        Swal.fire('Berhasil', 'Berhasil membuat Surat Tugas', 'success')
        this.$bvModal.hide('modal-surat-tugas')
        this.loadData()
        for (const d in this.formSuratTugas) {
          this.formSuratTugas[d] = ''
        }
      } catch (error) {
        Swal.fire('Gagal', 'Gagal membuat Surat Tugas', 'error')
      } finally {
        this.$loading(false)
        this.loadingModal = false
      }
    },

    tinjauLaporan(id) {
      axios
        .get(this.baseapiPengendalian + `api/penilaian_laporan?filter=id_laporan,=,${id}`, this.getApiOption())
        .then((res) => {
          const data = res.data.data[0]
          let url = `/app/penilaian-laporan-tahunan/tinjau?id_laporan=${id}`
          if (data) {
            url += `&id_penilaian=${data.id}`
          }
          this.$router.push(url)
        })
    },

    verifikasiLaporan(id) {
      axios
        .get(this.baseapiPengendalian + `api/penilaian_laporan?filter=id_laporan,=,${id}`, this.getApiOption())
        .then((res) => {
          const data = res.data.data[0]
          let url = `/app/penilaian-laporan-tahunan/verifikasi?id_laporan=${id}`
          if (data) {
            url += `&id_penilaian=${data.id}`
          }
          this.$router.push(url)
        })
    },

    async submitPenilaian(laporan) {
      const confirm = await Swal.fire({
        title: 'Apakah anda yakin ingin submit penilaian?',
        text: 'Tindakan ini tidak dapat dibatalkan',
        showDenyButton: true,
        confirmButtonText: 'Ya, submit',
        denyButtonText: 'Batal',
      })
      if (!confirm.isConfirmed) return false

      this.loadingModal = true
      this.$loading(true)

      // get penilaian
      const penilaian = (
        await axios.get(
          `${this.baseapiPengendalian}api/penilaian_laporan?filter=id_laporan,=,${laporan.id}`,
          this.getApiOption(),
        )
      ).data?.data[0]

      // get ttd penilai
      // const ttd_penilai = (
      //   await axios.get(
      //     `${this.baseapiPengendalian}api/tandatangan?filter=id_user,=,${this.user.id}`,
      //     this.getApiOption(),
      //   )
      // ).data?.data[0]
      // if (!ttd_penilai) {
      //   Swal.fire('Gagal', 'Anda belum memiliki tandatangan', 'error')
      //   this.$loading(false)
      //   return
      // }

      // get perizinan
      let perizinan = null
      if (laporan.jenis_kegiatan === 'Berusaha') {
        perizinan =
          (
            await axios.get(
              `${this.baseapiPengendalian}api/ref/getPermohonan/Berusaha?filter=nomor_oss,=,${laporan.nomor_kkprl}`,
              this.getApiOption(),
            )
          ).data?.data[0] || null
      } else if (laporan.jenis_kegiatan === 'Non Berusaha') {
        perizinan =
          (
            await axios.get(
              `${this.baseapiPengendalian}api/ref/getPermohonan/Nonberusaha?filter=nomor_kkp,=,${laporan.nomor_kkprl}`,
              this.getApiOption(),
            )
          ).data?.data[0] || null
      }

      try {
        // update status penilaian
        const reqpenilaian = (
          await axios.post(
            `${this.baseapiPengendalian}api/penilaian_laporan/getHasilPenilaian/${penilaian.id}`,
            { status: 'Selesai' },
            this.getApiOption(),
          )
        ).data

        // generate sertifikat laporan
        if (penilaian.total_skor >= 81 && penilaian.status_penyampaian === 'Tidak Telat') {
          await axios.post(
            `${this.baseapiPengendalian}api/penilaian_laporan/getSertifikat/${penilaian.id}`,
            { status: 'Selesai' },
            this.getApiOption(),
          )
        }

        if (reqpenilaian?.data?.id_filename) {
          this.openFileById(reqpenilaian.data.id_filename)
        }

        // update status laporan tahunan
        await axios.post(
          `${this.baseapiPengendalian}api/laporan_tahunan/${laporan.id}`,
          {
            status_penilaian_laporan: 'Selesai',
            masa_berlaku: penilaian.masa_berlaku,
            tanggal_penilaian: penilaian.tanggal_penilaian,
          },
          this.getApiOption(),
        )

        // update masa berlaku perizinan
        if (perizinan && penilaian.masa_berlaku && /^\d{4}-\d{2}-\d{2}$/.test(penilaian.masa_berlaku)) {
          if (laporan.jenis_kegiatan === 'Berusaha') {
            await axios.post(
              `${this.baseapiPengendalian}api/ref/updatePermohonan/Berusaha/${perizinan.id}`,
              { masa_berlaku: penilaian.masa_berlaku },
              this.getApiOption(),
            )
          } else if (laporan.jenis_kegiatan === 'Non Berusaha') {
            await axios.post(
              `${this.baseapiPengendalian}api/ref/updatePermohonan/Nonberusaha/${perizinan.id}`,
              { masa_berlaku: penilaian.masa_berlaku },
              this.getApiOption(),
            )
          }
        }

        this.loadData()
        Swal.fire('Berhasil', 'Hasil penilaian berhasil digenerate!', 'success')
      } catch (error) {
        // jika gagal, update status laporan tahunan ke draft
        await axios.post(
          `${this.baseapiPengendalian}api/laporan_tahunan/${laporan.id}`,
          { status_penilaian_laporan: 'Draft' },
          this.getApiOption(),
        )

        // jika gagal, update masa berlaku perizinan ke semula
        if (perizinan && perizinan.masa_berlaku) {
          if (laporan.jenis_kegiatan === 'Berusaha') {
            await axios.post(
              `${this.baseapiPengendalian}api/ref/updatePermohonan/Berusaha/${perizinan.id}`,
              { masa_berlaku: perizinan.masa_berlaku },
              this.getApiOption(),
            )
          } else if (laporan.jenis_kegiatan === 'Non Berusaha') {
            await axios.post(
              `${this.baseapiPengendalian}api/ref/updatePermohonan/Nonberusaha/${perizinan.id}`,
              { masa_berlaku: perizinan.masa_berlaku },
              this.getApiOption(),
            )
          }
        }

        Swal.fire('Gagal', 'Gagal submit penilaian', 'error')
      } finally {
        this.$loading(false)
        this.loadingModal = false
      }
    },

    async handleRollback(id) {
      const confirm = await Swal.fire({
        title: 'Konfirmasi Rollback',
        text: 'Apakah Anda yakin ingin melakukan Rollback pada Laporan Tahunan ini? Tindakan ini tidak bisa dibatalkan',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, Rollback',
        cancelButtonText: 'Batal',
      })
      if (!confirm.isConfirmed) return
      this.$loading(true)
      try {
        await axios.put(`${this.baseapiPengendalian}api/laporan_tahunan/setRollback/${id}`, {}, this.getApiOption())
        await axios.post(
          `${this.baseapiPengendalian}api/laporan_tahunan/${id}`,
          { jenis_verifikator: null, status_pembuatan_surat_tugas: null, status_penilaian_laporan: null },
          this.getApiOption(),
        )
        Swal.fire('Berhasil', 'Berhasil melakukan Rollback pada Laporan Tahunan', 'success')
        this.loadData()
      } catch (error) {
        Swal.fire('Gagal', 'Gagal melakukan Rollback pada Laporan Tahunan', 'error')
      } finally {
        this.$loading(false)
      }
    },

    async unduhFile(d) {
      const [id_dokumen, type] = d.split(':')
      if (type === 'merged') {
        Swal.fire('Unduh File Dalam Proses', 'Mohon untuk tidak menutup atau me-refresh halaman', 'info')
        await this.getCombinedPDF(id_dokumen)
        this.$toasted.success('Unduh file selesai')
      } else {
        await this.openFileById(id_dokumen)
      }
    },

    async getCombinedPDF(id_laporan) {
      await axios
        .get(
          `${this.baseapiPengendalian}api/laporan_tahunan/getCombinedPDF/${id_laporan}`,
          this.getApiOption({ responseType: 'blob' }),
        )
        .then((res) => {
          const file = new Blob([res.data], { type: res.data.type })
          const fileURL = URL.createObjectURL(file)
          window.open(fileURL, '_blank')
        })
    },

    isValidPenilai(record) {
      return this.user.id == record.id_penilai
    },

    getStatusLaporan(record) {
      const status = [
        'Draft',
        'Komentar/Informasi terhadap Penyampaian Laporan Tahunan',
        ['Laporan telah disubmit', 'Laporan telah disubmit ulang'],
        'Laporan telah diterima',
        'Laporan sedang dalam proses penilaian',
        'Selesai',
      ]
      return status.findIndex((item) =>
        Array.isArray(item)
          ? item.includes(record.status_laporan)
          : item === record.status_laporan
      )
    },

    getStatusPenilaian(record) {
      const status = ['Draft', 'Selesai']
      return status.findIndex((d) => d === record.status_penilaian_laporan)
    },

    async getData() {
      $('#tabel_laporan_tahunan').DataTable().destroy()
      await this.loadData()
    },

    async loadData() {
      let user = ''
      if (this.hasRole(this.user, 'Superuser')) {
        user = `;status_laporan,!=,Draft`
      } else if (this.hasRole(this.user, 'Verifikator')) {
        if (this.user.nama_upt === 'PUSAT') {
          user = `;jenis_verifikator,=,Pusat`
        } else {
          user = `;jenis_verifikator,=,UPT;nama_upt,=,${this.user.nama_upt}`
        }
      } else if (this.hasRole(this.user, 'Penilai')) {
        // user = `;id_penilai,=,${this.user.id};status_pembuatan_surat_tugas,!=,null`
        user = `;id_penilai,=,${this.user.id}`
      } else if (this.hasRole(this.user, 'TimPengawas')) {
        user = `;status_laporan,!=,Draft`
      } else if (this.hasRole(this.user, 'Pejabat')) {
        user = `;status_laporan,!=,Draft`
      }
      const searchFilter = this.getSearchFilter()
      // prettier-ignore
      const api = `api/laporan_tahunan`+
        `?page=${this.pagination.currentPage}`+
        `&filter=status_laporan,!=,null${user}${searchFilter ? `;${searchFilter}` : ''}`+
        `&sort=${this.sort.field},${this.sort.direction};createdAt,DESC`
      axios
        .get(this.baseapiPengendalian + api, this.getApiOption())
        .then((response) => {
          const res = response.data
          this.pagination.limit = res.limit
          this.pagination.total = res.total
          this.pagination.firstInPage = (this.pagination.currentPage - 1) * res.limit + 1
          this.pagination.lastPage = Math.ceil(res.total / res.limit)
          this.setPagination()
          this.dataLaporan = this.getDataLaporanText(response.data?.data)
          this.loadDataRoomChat()
        })
        .catch((error) => {})
        .finally(() => {
          this.initDatatable()
        })
    },

    async loadDataRoomChat() {
      const res = await axios.get(
        `${this.baseapiPengendalian}api/chat_room?filter=id_penilai,=,${this.user.id}`,
        this.getApiOption(),
      )
      const setActiveRoomChat = new Set()
      for (const d of res.data.data) {
        if (!d.tt_chats[0].read && d.tt_chats[0].id_pengirim !== `${this.user.id}`) {
          setActiveRoomChat.add(Number(d.id_laporan))
        }
      }
      const result = []
      for (const d of this.dataLaporan) {
        if (setActiveRoomChat.has(d.id)) {
          d.unread_chat = true
        }
        result.push(d)
      }
      this.dataLaporan = result
    },

    setPagination() {
      this.$router
        .replace({
          path: this.$route.path,
          query: { page: this.pagination.currentPage },
        })
        .catch((err) => {})
      this.pagination.pageNumber = []
      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('2')
          this.pagination.pageNumber.push('3')
          this.pagination.pageNumber.push('4')
          this.pagination.pageNumber.push('5')
        } else if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 4}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 3}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 2}`)
        } else {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.currentPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage + 1}`)
        }
        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next') {
        if (this.pagination.currentPage < this.pagination.lastPage) {
          this.pagination.currentPage++
        }
      }
      if (config.option === 'prev') {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage--
        }
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        this.pagination.currentPage = parseInt(config.page)
      }
      this.setPagination()
      await this.getData()
      $('html,body').scrollTop(1000)
    },

    deleteLaporan(id) {
      Swal.fire({
        title: 'Apakah Anda yakin?',
        text: 'Anda tidak akan dapat mengembalikan data ini!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, hapus',
        cancelButtonText: 'Batal',
      }).then(async (result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapiPengendalian + 'api/laporan_tahunan/' + id, this.getApiOption())
            .then((response) => {
              Swal.fire('Berhasil', 'Berhasil menghapus laporan tahunan', 'success')
              $('#tabel_laporan_tahunan').DataTable().destroy()
              this.loadData()
            })
            .catch((error) => {
              Swal.fire('Gagal', 'Gagal menghapus laporan tahunan', 'error')
            })
        }
      })
    },

    calculateMasaBerlaku(masa_berlaku, terbit_kkprl) {
      const t_masa_berlaku = new Date(masa_berlaku).getDate()
      if (!isNaN(t_masa_berlaku)) {
        const d1 = new Date(masa_berlaku)
        const d2 = new Date(terbit_kkprl)
        return `${Math.abs(d1.getFullYear() - d2.getFullYear())} tahun`
      } else {
        return '-'
      }
    },

    initDatatable() {
      setTimeout(() => {
        $.fn.dataTable.moment('DD MMMM YYYY')
        var t = $('#tabel_laporan_tahunan').DataTable({
          pagingType: 'full_numbers',
          language: {
            info: 'Menampilkan _START_ sampai _END_ dari _TOTAL_ data',
            paginate: {
              first: 'Awal',
              last: 'Akhir',
              next: 'Selanjutnya',
              previous: 'Sebelumnya',
            },
          },
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 2, right: 1 },
          scrollX: true,
          dom: 'Bfrtip',
          buttons: [],
        })
      }, 300)
    },

    exportData() {
      this.$loading(true);
      let user = ''
      if (this.hasRole(this.user, 'Superuser')) {
        user = `;status_laporan,!=,Draft`
      } else if (this.hasRole(this.user, 'Verifikator')) {
        if (this.user.nama_upt === 'PUSAT') {
          user = `;jenis_verifikator,=,Pusat`
        } else {
          user = `;jenis_verifikator,=,UPT;nama_upt,=,${this.user.nama_upt}`
        }
      } else if (this.hasRole(this.user, 'Penilai')) {
        user = `;id_penilai,=,${this.user.id};status_pembuatan_surat_tugas,!=,null`
      }
      const searchFilter = this.getSearchFilter()
      // prettier-ignore
      const api = `api/laporan_tahunan`+
        `?page=${this.pagination.currentPage}`+
        `&filter=status_laporan,!=,null${user}${searchFilter ? `;${searchFilter}` : ''}`+
        `&sort=${this.sort.field},${this.sort.direction};createdAt,DESC`+
        `&limit=0`
      axios
        .get(this.baseapiPengendalian + api, this.getApiOption())
        .then((response) => {
          const data = this.getDataLaporanText(response.data?.data).map((d, i) => {
            return {
              no: i + 1,
              ...d,
            }
          })
          const header = {
            no: 'No',
            nama_pemegang: 'Nama Pemohon',
            email: 'Email',
            no_telepon: 'No Telepon',
            jenis_kegiatan: 'Jenis Permohonan',
            nomor_kkprl: 'Nomor Izin Terbit',
            tanggal_penerbitan: 'Tgl. Izin Terbit',
            tahun_laporan: 'Tahun Laporan',
            tanggal_submit_laporan: 'Tgl. Pelaporan',
            status_penyampaian: 'Status Penyampaian',
            provinsi: 'Lokasi',
            jenis_verifikator: 'Verifikator',
            nama_penilai: 'Penilai',
            tanggal_penilaian: 'Tgl. Penilaian',
            nilai: 'Nilai',
            total_skor: 'Skor',
            kategori_penilaian: 'Kategori',
            masa_berlaku: 'Masa Berlaku',
            persetujuan_lingkungan: 'Persetujuan Lingkungan',
            ket_persetujuan_lingkungan: 'Ket. Persetujuan Lingkungan',
            perizinan_usaha: 'Perizinan Usaha',
            ket_perizinan_usaha: 'Ket. Perizinan Usaha',
            status_laporan: 'Status',
            status_kewajiban_1: 'K1',
            bentuk_kegiatan_1: 'Ket K1',
            status_kewajiban_4: 'K4',
            bentuk_kegiatan_4: 'Ket K4',
            status_kewajiban_5: 'K5',
            bentuk_kegiatan_5: 'Ket K5',
            status_kewajiban_8: 'K8',
            bentuk_kegiatan_8: 'Ket K8',
            status_kewajiban_10: 'K10',
            bentuk_kegiatan_10: 'Ket K10',
          }
          this.exportToExcel({
            data,
            header,
            fileName: `Penilaian Laporan Tahunan ${formatDate(new Date(), 'YYYY-MM-DD')}`,
          })
        })
        .catch((error) => {})
        .finally(() => {
          this.$loading(false)
        })
    },

    getDataLaporanText(data) {
      if (!data) return []
      return data.map((d) => {
        const persetujuan_lingkungan =
          d.status_persetujuan_lingkungan === 'Sudah'
            ? d.file_persetujuan_lingkungan
              ? 'Ada - Dilampirkan'
              : 'Ada - Tidak Dilampirkan'
            : 'Tidak Ada'
        const ket_persetujuan_lingkungan =
          d.status_persetujuan_lingkungan === 'Sudah'
            ? `Izin lingkungan no. ${d.nomor_persetujuan_lingkungan} ` +
              `tanggal ${this.formatDate(d.tanggal_terbit_persetujuan_lingkungan, 'DD/MM/YYYY')} ` +
              `instansi penerbit ${d.instansi_penerbit_persetujuan_lingkungan} ` +
              `masa berlaku ${d.masa_berlaku_persetujuan_lingkungan} tahun`
            : '-'
        const perizinan_usaha =
          d.jenis_kegiatan === 'Berusaha'
            ? d.status_perizinan_berusaha === 'Sudah'
              ? d.perizinan_berusaha?.file_perizinan_berusaha
                ? 'Ada - Dilampirkan'
                : 'Ada - Tidak Dilampirkan'
              : 'Tidak Ada'
            : d.status_perizinan_nonberusaha === 'Sudah'
            ? d.perizinan_nonberusaha?.file_perizinan_nonberusaha
              ? 'Ada - Dilampirkan'
              : 'Ada - Tidak Dilampirkan'
            : 'Tidak Ada'
        const ket_perizinan_usaha =
          d.jenis_kegiatan === 'Berusaha'
            ? d.status_perizinan_berusaha === 'Sudah'
              ? `Perizinan no. ${d.perizinan_berusaha?.nomor_perizinan_berusaha} ` +
                `tanggal ${this.formatDate(d.perizinan_berusaha?.tanggal_terbit_perizinan_berusaha, 'DD/MM/YYYY')} ` +
                `instansi penerbit ${d.perizinan_berusaha?.instansi_penerbit_perizinan_berusaha} ` +
                `masa berlaku ${d.perizinan_berusaha?.masa_berlaku_perizinan_berusaha} tahun`
              : '-'
            : d.status_perizinan_nonberusaha === 'Sudah'
            ? `Perizinan no. ${d.perizinan_nonberusaha?.nomor_perizinan_nonberusaha} ` +
              `tanggal ${this.formatDate(
                d.perizinan_nonberusaha?.tanggal_terbit_perizinan_nonberusaha,
                'DD/MM/YYYY',
              )} ` +
              `instansi penerbit ${d.perizinan_nonberusaha?.instansi_penerbit_perizinan_nonberusaha} ` +
              `masa berlaku ${d.perizinan_nonberusaha?.masa_berlaku_perizinan_nonberusaha} tahun`
            : '-'

        const terbit = new Date(d.tanggal_penerbitan)
        terbit.setFullYear(Number(d.tahun_laporan))
        terbit.setHours(0, 0, 0, 0)
        const lapor = new Date(d.tanggal_submit_laporan)
        lapor.setHours(0, 0, 0, 0)

        const status_penyampaian = lapor >= terbit ? 'Telat' : 'Tidak Telat'

        const masa_berlaku = d.masa_berlaku ? d.masa_berlaku : d.status_laporan === 'Selesai' ? 'Selama Menjalankan Kegiatan Usaha' : ''

        return {
          ...d,
          selected_file: '#',
          persetujuan_lingkungan,
          ket_persetujuan_lingkungan,
          perizinan_usaha,
          ket_perizinan_usaha,
          provinsi: d.provinsi ? d.provinsi[0] : '-',
          status_penyampaian,
          masa_berlaku,
        }
      })
    },

    toggleModalChat(d) {
      d.unread_chat = false
      this.selectedLaporan = d
      this.$bvModal.show('modal-chat')
    },

    getApiOption(option = {}) {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
        ...option,
      }
    },

    manualValidation(field, name) {
      if (!field) {
        this.$validator.errors.add({
          field: name,
          msg: 'Wajib diisi',
        })
        return false
      } else {
        return true
      }
    },

    manualRemoveError(name) {
      this.$validator.errors.remove(name)
    },
  },

  watch: {
    filters: {
      handler: function (val) {
        if (this.debounceTerm) {
          clearTimeout(this.debounceTerm)
        }
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.getData()
        }, 1000)
      },
      deep: true,
    },
    sort: {
      handler: function (val) {
        this.pagination.currentPage = 1
        this.getData()
      },
      deep: true,
    },
    'formSuratTugas.id_penilai'() {
      this.manualRemoveError('Tim Penilai')
    },
    // 'formSuratTugas.nomor_surat'() {
    //   this.manualRemoveError('Nomor Surat')
    // },
    // 'formSuratTugas.menimbang'() {
    //   this.manualRemoveError('Menimbang')
    // },
    // 'formSuratTugas.dasar'() {
    //   this.manualRemoveError('Dasar')
    // },
    // 'formSuratTugas.untuk'() {
    //   this.manualRemoveError('Untuk')
    // },
    'formSuratTugas.penandatangan'() {
      this.manualRemoveError('Penandatangan')
    },
    'formSuratTugas.dipa'() {
      this.manualRemoveError('DIPA')
    },
    // 'formSuratTugas.paragraf_penutup'() {
    //   this.manualRemoveError('Paragraf Penutup')
    // },
    'formSuratTugas.tempat_ttd'() {
      this.manualRemoveError('Tempat Tandatangan')
    },
    'formSuratTugas.tanggal_surat'() {
      this.manualRemoveError('Tanggal Surat')
    },
  },
}
</script>

<style src="./Wizard.scss" lang="scss" />
<style src="./Elements.scss" lang="scss" />
<style scoped>
.btn-submit {
  border: none;
  border-radius: 0.45rem;
  background-color: #ebb834;
  padding: 0.4rem 0.8rem;
  font-size: 0.875rem;
  color: white;
  cursor: pointer;
  outline: none;
  animation: pulse-glow-yellow 2s infinite ease-in-out;
}

.btn-submit:hover {
  background-color: #ffce50;
}

@keyframes pulse-glow-yellow {
  0% {
    box-shadow: 0 0 5px 0px rgba(238, 195, 82, 0.7);
  }
  50% {
    box-shadow: 0 0 20px 8px rgba(238, 195, 82, 0.7);
  }
  100% {
    box-shadow: 0 0 5px 0px rgba(238, 195, 82, 0.7);
  }
}

.btn-diskusi-active::after {
  content: '';
  position: absolute;
  top: 0px;
  right: 0px;
  width: 10px;
  height: 10px;
  background: #c93626;
  border-radius: 100%;
  transform: translate(50%, -50%);
  animation: pulse-badge-glow 2s infinite ease-in-out;
}
</style>
